import messages from './memberMessagingCompose.json' with { type: 'json' };

export const memberMessagingComposeFi: Readonly<typeof messages> = messages;
